// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3q50t","buttons":"Footer_buttons__3ouuq"};